import { forwardRef, type ReactNode } from 'react';

import { cn } from '@nesso/ui/lib/utils';

type Props = {
    className?: string;
    disabled?: boolean;
    onClick: () => void;
    fieldContent: ReactNode;
    triggerButton: ReactNode;
    contentId?: string;
};

export const MultiSelectField = forwardRef<HTMLDivElement, Props>(
    ({ className, disabled, onClick, fieldContent, triggerButton, contentId }, ref) => (
        <div
            ref={ref}
            data-slot="multi-select-field"
            onClick={onClick}
            className={cn(
                'inline-flex items-center justify-between gap-2 rounded-md border shadow-none text-sm font-medium',
                'h-auto min-h-8 bg-background px-3 py-1.5 dark:bg-input/5 dark:border-input',
                'has-[[role=combobox]:focus-visible]:border-ring has-[[role=combobox]:focus-visible]:ring-2 has-[[role=combobox]:focus-visible]:ring-accent/50',
                'has-[[role=combobox][aria-invalid=true]]:border-destructive has-[[role=combobox][aria-invalid=true]]:ring-destructive/20 dark:has-[[role=combobox][aria-invalid=true]]:ring-destructive/40',
                // Radix's modal Popover sets pointer-events:none on <body> while open, which the
                // field would otherwise inherit now that the remove buttons live outside the
                // actual PopoverTrigger. Force it back on so removing a chip works while open.
                !disabled &&
                    'pointer-events-auto cursor-pointer hover:bg-accent hover:text-accent-foreground',
                disabled && 'pointer-events-none cursor-not-allowed opacity-50',
                className,
            )}
        >
            <div id={contentId} className="min-w-0 flex-1">
                {fieldContent}
            </div>
            {triggerButton}
        </div>
    ),
);
MultiSelectField.displayName = 'MultiSelectField';
